import { render, staticRenderFns } from "./AssetsManagement.vue?vue&type=template&id=5deba0ce&"
import script from "./AssetsManagement.vue?vue&type=script&lang=js&"
export * from "./AssetsManagement.vue?vue&type=script&lang=js&"
import style0 from "./AssetsManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports